import ReportExplorerModal from './ReportExplorerModal';

export default ReportExplorerModal;
